<!-- DetailHeader.vue -->
<template>
	<div class="ui-detail-header">
		<img class="left" src="../../assets/image/change-icon/back@2x.png" v-on:click='goBack()'>
		<div class="navbar-wrapper">
			<div v-for="(item, key) in data" v-bind:class="{'navbar_active': key == index}" v-on:click='changeEvent(key)'>{{item.name}}</div>
		</div>
	</div>
</template>

<script>
import { header } from './static';
import { mapState, mapMutations } from 'vuex'
export default {
	data(){
		return {
			data: header
		}
	},

	computed: {
		...mapState({
			detailInfo: state => state.detail.detailInfo,
			index: state => state.detail.index
		})
	},
	created(){
		if(this.getQueryVariable('shopId') || this.getQueryVariable('cid')){
			window.sessionStorage.setItem("firstInto","true")
		}
	},
	beforeDestroy(){
		window.sessionStorage.removeItem("firstInto")
	},
	methods: {
		...mapMutations({
			'changeIndex': 'changeIndex',
		}),
		changeEvent(index) {
			this.changeIndex(index);
		},
		getQueryVariable(variable){
				let query = window.location.search.substring(1);
				let vars = query.split("&");
				for (let i=0;i<vars.length;i++) {
						let pair = vars[i].split("=");
						if(pair[0] == variable){return pair[1];}
				}
				let value = this.$route.query[variable]
				return value || false;
		},
		goBack() {	
			if(window.sessionStorage.getItem("firstInto")=="true"){
				window.sessionStorage.setItem("firstInto","false")
				this.$router.push('/')
			}else{
				this.$router.go(-1)
			}
		}
	}
}

</script>

<style lang='scss'>
	.ui-detail-header {
		padding: 0px 9px;
		height:44px;
		background:rgba(255,255,255,1);
		border-bottom: 0.5px solid rgba(232,234,237,1);
		color: #55595F;
		font-size: 17px;
		width: auto;
		display: flex;
		justify-content: center;
		align-content: center;
		align-items: center;
	    flex-basis: auto;
	    position: absolute;
	    top: 0px;
	    left: 0px;
	    right: 0px;
		.left {
			width: 24px;
			height: 24px;
			cursor: pointer;
			position: absolute;
			left: 9px;
			top: 10px;
		}
		.right {
			width: 24px;
			height: 24px;
			cursor: pointer;
			position: absolute;
			right: 9px;
			top: 10px;
		}
		div.navbar-wrapper {
			div {
	    		line-height: 42px;
	    		border-bottom: 0px;
	    		display: inline-block;
	    		margin-right: 48px;
	    		color: #55595F;
	    		background-color: #fff;
				&.navbar_active {
					color: $primaryColor;
					border-bottom: 2px solid $primaryColor;
				}
				&:last-child {
					margin-right: 0px;
				}
				&:focus {
					outline: none;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/product-detail/DetailHeader.vue